import { ReactElement } from 'react';

import { TherapeuticGroupPractitioner } from '@dreryk/egabinet-group-session-frontend-api';

import { Text } from '@dreryk/react-components';
import { practitionerNameFormatter } from '@dreryk/react-common';

type PractitionersCellProps = {
   readonly practitioners: TherapeuticGroupPractitioner[];
};

export const PractitionersCell = (props: PractitionersCellProps): ReactElement => {
   return (
      <Text testId={'practitioners'}>
         <strong>
            {props.practitioners.map((practitioner) => practitionerNameFormatter(practitioner)).join(', ')}
         </strong>
      </Text>
   );
};
